// 设置相关翻译 - 系统设置、个人设置等

export const zh = {
  version: '版本',
  modelProviders: '模型提供商',
  disabledProviders: '已停用',
  administrator: '管理员',
  userManagement: '用户管理',
  themeSoft: '柔和',
  themeDark: '黑暗',
  uuid: 'UUID',
  userRole: '角色',
  plan: '套餐',
  registeredAt: '注册时间',
  sbDbConnected: '数据库已连接',
  sbDbDisconnected: '数据库未连接',
  sbJump: '跳转',
  // Settings
  theme: '主题',
  language: '语言',
  userSettings: '个人设置',
  modelConfig: '模型配置',
  modelPrefsSaved: '模型偏好已保存',

  // Personal Settings Dialog
  uploadAvatar: '上传头像',
  removeAvatar: '移除',
  username: '用户名',
  usernamePlaceholder: '请输入用户名',
  usernameHint: '2-20 个字符',
  userConfig: '用户配置',
  savingUserSettings: '保存中...',

  // Settings Dialog (System Config)
  defaultModel: '默认模型',

  // Model Config Dialog (Simple 模式偏好)
  simpleMode: 'Simple 模式（直接对话）',
  followSystemDefault: '跟随系统默认',
  thinkingMode: '思考模式',
  thinkingAuto: '跟随系统',
  thinkingOn: '开启',
  thinkingOff: '关闭',
  thinkingUnsupported: '当前模型不支持思考模式开关',
  thinkingCostHint: '开启思考模式可提升复杂问题的回答质量，但响应更慢、token 消耗更高',
  complexModeDesc: 'Complex 模式（多专家任务）的模型由管理员在「能力包管理」中配置。',
  systemStatus: '系统状态',
  migrationsUpToDate: '迁移已对齐',
  missingKey: '未配置 Key',
  dailyTokenQuota: '每用户日 token 配额',
  quotaUnlimited: '留空 = 不限量',
  quotaHint: '每个用户每天可消耗的 token 总量上限（UTC 日界重置），留空表示不限量。新任务在达到上限后将被拦截。',
  quotaInvalid: '配额必须是正整数或留空',
  quotaSaved: '配额已更新',
  graphConcurrency: '同层任务并发上限',
  graphConcurrencyHint: '计划里互不依赖的任务同时跑几个。1 = 完全串行（默认）；调高会更快，但更容易撞上模型服务商的速率限制，成本也更集中。',
  graphConcurrencyEffective: '当前生效',
  graphConcurrencyFromEnv: '来自环境变量',
  graphConcurrencyInvalid: '并发上限必须是 1 到 {limit} 之间的整数，或留空恢复串行',
  graphConcurrencySaved: '并发上限已更新（下一个任务起生效）',
  modelsLoading: '正在加载模型列表...',
  modelsLoadFailed: '模型列表加载失败，请稍后重试',
  openSource: '开源仓库',
  navAbout: '关于',
  versionLabel: '当前版本',
  aboutHint: 'XPouch 是一个开源自托管的多用户 AI 工作台——对话、复杂任务与产物管理，数据完全属于你自己。',
  byokTitle: 'API Keys',
  byokDesc: '自带 provider API Key（BYOK）：保存后该 provider 的请求走你自己的 key 计费，删除即回退实例默认。Key 加密存储，明文不再可见。',
  byokDisabledHint: '本实例未启用 BYOK（管理员未配置 BYOK_MASTER_KEY）。',
  byokProvider: '提供商',
  byokProviderPlaceholder: '选择提供商…',
  byokKeyPlaceholder: '粘贴 API Key（sk-…）',
  byokSave: '保存',
  byokInvalidInput: '请选择提供商并粘贴至少 8 位的 Key',
  byokSaved: '已保存（加密存储）',
  byokDeleted: '已删除，回退实例默认 Key',
  byokEmpty: '尚未保存任何 Key——不保存则始终使用实例默认。',
  byokTest: '测试连接',
  byokTestOk: '连接成功',
  byokTestFail: '连接失败',
  byokFallbackHint: '优先级：你的 Key > 实例默认；未配置的 provider 自动走实例默认。',
  byokAdminReadonly: '管理员只读掩码',
}

export const en = {
  version: 'Version',
  modelProviders: 'Model providers',
  disabledProviders: 'Disabled',
  administrator: 'Administrators',
  userManagement: 'User Management',
  themeSoft: 'Soft',
  themeDark: 'Dark',
  uuid: 'UUID',
  userRole: 'Role',
  plan: 'Plan',
  registeredAt: 'Registered',
  sbDbConnected: 'Database connected',
  sbDbDisconnected: 'Database disconnected',
  sbJump: 'Navigate',
  // Settings
  theme: 'Theme',
  language: 'Language',
  userSettings: 'User Settings',
  modelConfig: 'Model Config',
  modelPrefsSaved: 'Model preferences saved',

  // Personal Settings Dialog
  uploadAvatar: 'Upload Avatar',
  removeAvatar: 'Remove',
  username: 'Username',
  usernamePlaceholder: 'Enter username',
  usernameHint: '2-20 characters',
  userConfig: 'USER CONFIG',
  savingUserSettings: 'Saving...',

  // Settings Dialog (System Config)
  defaultModel: 'DEFAULT MODEL',

  // Model Config Dialog (Simple mode preferences)
  simpleMode: 'SIMPLE MODE (DIRECT CHAT)',
  followSystemDefault: 'Follow System Default',
  thinkingMode: 'Thinking Mode',
  thinkingAuto: 'Follow system',
  thinkingOn: 'On',
  thinkingOff: 'Off',
  thinkingUnsupported: 'This model does not support the thinking toggle',
  thinkingCostHint: 'Enabling thinking improves quality on complex questions, but is slower and costs more tokens',
  complexModeDesc: 'Complex mode (multi-expert tasks) models are configured by the administrator in Capability Packs.',
  systemStatus: 'SYSTEM',
  migrationsUpToDate: 'Migrations up to date',
  missingKey: 'Key missing',
  dailyTokenQuota: 'Per-user daily token quota',
  quotaUnlimited: 'Empty = unlimited',
  quotaHint: 'Max tokens one user may consume per day (resets at UTC midnight). New tasks are blocked once the limit is reached. Leave empty for unlimited.',
  quotaInvalid: 'Quota must be a positive integer or empty',
  quotaSaved: 'Quota updated',
  graphConcurrency: 'Task concurrency limit',
  graphConcurrencyHint: 'How many independent tasks of one plan run at the same time. 1 = fully serial (default); higher is faster but hits provider rate limits sooner and concentrates cost.',
  graphConcurrencyEffective: 'Effective',
  graphConcurrencyFromEnv: 'from environment',
  graphConcurrencyInvalid: 'Concurrency must be an integer between 1 and {limit}, or empty to restore serial',
  graphConcurrencySaved: 'Concurrency updated (applies to the next task)',
  modelsLoading: 'Loading model list...',
  modelsLoadFailed: 'Failed to load model list, please retry later',
  openSource: 'Open Source',
  navAbout: 'About',
  versionLabel: 'Version',
  aboutHint: 'XPouch is an open-source, self-hosted multi-user AI workbench — chat, complex tasks and artifact management, with data that stays yours.',
  byokTitle: 'API Keys',
  byokDesc: 'Bring your own provider API keys (BYOK): requests on a saved provider bill to your own key; delete to fall back to the instance default. Keys are stored encrypted — plaintext is never shown again.',
  byokDisabledHint: 'BYOK is not enabled on this instance (BYOK_MASTER_KEY unset by the admin).',
  byokProvider: 'Provider',
  byokProviderPlaceholder: 'Select a provider…',
  byokKeyPlaceholder: 'Paste API Key (sk-…)',
  byokSave: 'Save',
  byokInvalidInput: 'Pick a provider and paste a key of at least 8 characters',
  byokSaved: 'Saved (encrypted)',
  byokDeleted: 'Deleted — falling back to instance key',
  byokEmpty: 'No keys saved yet — the instance default applies.',
  byokTest: 'Test connection',
  byokTestOk: 'Connection OK',
  byokTestFail: 'Connection failed',
  byokFallbackHint: 'Priority: your key > instance default; providers without a saved key always use the instance default.',
  byokAdminReadonly: 'admin view: masked',
}

export const ja = {
  version: 'バージョン',
  modelProviders: 'モデルプロバイダー',
  disabledProviders: '無効化',
  administrator: '管理者',
  userManagement: 'ユーザー管理',
  themeSoft: 'ソフト',
  themeDark: 'ダーク',
  uuid: 'UUID',
  userRole: 'ロール',
  plan: 'プラン',
  registeredAt: '登録日時',
  sbDbConnected: 'データベース接続済み',
  sbDbDisconnected: 'データベース未接続',
  sbJump: '移動',
  // Settings
  theme: 'テーマ',
  language: '言語',
  userSettings: '個人設定',
  modelConfig: 'モデル設定',
  modelPrefsSaved: 'モデル設定を保存しました',

  // Personal Settings Dialog
  uploadAvatar: 'アバターをアップロード',
  removeAvatar: '削除',
  username: 'ユーザー名',
  usernamePlaceholder: 'ユーザー名を入力',
  usernameHint: '2-20文字',
  userConfig: 'ユーザー設定',
  savingUserSettings: '保存中...',

  // Settings Dialog (System Config)
  defaultModel: 'デフォルトモデル',

  // Model Config Dialog (Simple モード設定)
  simpleMode: 'Simpleモード（直接会話）',
  followSystemDefault: 'システム既定に従う',
  thinkingMode: '思考モード',
  thinkingAuto: 'システム従来',
  thinkingOn: 'オン',
  thinkingOff: 'オフ',
  thinkingUnsupported: 'このモデルは思考モード切替に非対応です',
  thinkingCostHint: '思考モードを有効にすると複雑な質問の品質が向上しますが、応答が遅くトークン消費も増えます',
  complexModeDesc: 'Complexモード（マルチエキスパート）のモデルは管理者が「能力パック管理」で設定します。',
  systemStatus: 'システム状態',
  migrationsUpToDate: 'マイグレーション同期済み',
  missingKey: 'Key 未設定',
  dailyTokenQuota: 'ユーザー別 1 日トークン上限',
  quotaUnlimited: '空欄 = 無制限',
  quotaHint: '各ユーザーが 1 日に消費できるトークン上限（UTC 0 時にリセット）。上限に達すると新しいタスクは実行できません。空欄で無制限。',
  quotaInvalid: '上限は正の整数、または空欄にしてください',
  quotaSaved: '上限を更新しました',
  graphConcurrency: '同階層タスクの同時実行上限',
  graphConcurrencyHint: '1 つの計画のうち依存関係のないタスクを同時にいくつ実行するか。1 = 完全直列（既定）。上げると速くなりますが、プロバイダーのレート制限に当たりやすく、コストも集中します。',
  graphConcurrencyEffective: '現在の適用値',
  graphConcurrencyFromEnv: '環境変数より',
  graphConcurrencyInvalid: '同時実行数は 1〜{limit} の整数、または空欄で直列に戻してください',
  graphConcurrencySaved: '同時実行数を更新しました（次のタスクから適用）',
  modelsLoading: 'モデルリストを読み込み中...',
  modelsLoadFailed: 'モデルリストの取得に失敗しました。後でもう一度お試しください',
  openSource: 'オープンソース',
  navAbout: '情報',
  versionLabel: 'バージョン',
  aboutHint: 'XPouch はオープンソースのセルフホスト型マルチユーザー AI ワークベンチです。チャット、複雑なタスク、成果物管理——データはあなたのもの。',
  byokTitle: 'API Keys',
  byokDesc: 'プロバイダー API Key の持ち込み（BYOK）：保存したプロバイダーへのリクエストは自分の Key で課金され、削除するとインスタンス既定へ戻ります。Key は暗号化保存され、平文は再表示されません。',
  byokDisabledHint: 'このインスタンスでは BYOK が無効です（管理者が BYOK_MASTER_KEY 未設定）。',
  byokProvider: 'プロバイダー',
  byokProviderPlaceholder: 'プロバイダーを選択…',
  byokKeyPlaceholder: 'API Key を貼り付け（sk-…）',
  byokSave: '保存',
  byokInvalidInput: 'プロバイダーを選び、8 文字以上の Key を貼り付けてください',
  byokSaved: '保存しました（暗号化）',
  byokDeleted: '削除しました — インスタンス既定へ戻ります',
  byokEmpty: '保存された Key はありません — インスタンス既定が使われます。',
  byokTest: '接続テスト',
  byokTestOk: '接続成功',
  byokTestFail: '接続失敗',
  byokFallbackHint: '優先順位：自分の Key ＞ インスタンス既定。未設定のプロバイダーは常にインスタンス既定です。',
  byokAdminReadonly: '管理者はマスク閲覧のみ',
}
